import React from "react";
import { SCROLL_OFFSET } from "./sections";

const STEPS = [
  {
    number: "01",
    title: "Open Google Docs",
    body: "Zero Typing AI sits on your desktop, ready whenever you need it.",
  },
  {
    number: "02",
    title: "Speak naturally",
    body: "Talk the way you would explain something to a coworker. No punctuation commands, no slowing your pace.",
  },
  {
    number: "03",
    title: "Watch clean text appear",
    body: "Zero Typing AI adds punctuation, capitalization, and paragraph breaks automatically.",
  },
  {
    number: "04",
    title: "Edit with your voice or keyboard",
    body: "Fix a word, add a sentence, or keep dictating. Never locked into one mode.",
  },
];

const HowItWorksSection = () => {
  return (
    <section
      id="how-it-works"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className="w-full lg:max-w-[815.58px]"
    >
      <h2 className="font-jakarta font-bold text-[#0A0D16] text-[28px] sm:text-[36px] md:text-[44px] lg:text-[50px] leading-[1.28] lg:leading-[64px] tracking-[-0.8px]">
        How Zero Typing AI Works in Google Docs
      </h2>

      <p className="mt-[25.76px] font-inter text-[16px] font-normal leading-[29.6px] tracking-[0px] text-[#0A0D16B2]">
        Zero Typing AI runs quietly in the background while you write. Here&apos;s
        what using it actually looks like:
      </p>

      {/* Steps - 30.05px top padding, 2×2 grid with 17.17px gutters */}
      <div className="pt-[30.05px]">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-[17.17px]">
          {STEPS.map(({ number, title, body }) => (
            <article
              key={number}
              className="rounded-[17.17px] border-[1.34px] border-[#E6ECF5] bg-[#F7FAFF] p-[16px] sm:p-[21.46px]"
            >
              <span className="block font-jakarta text-[22px] font-bold leading-[29.64px] tracking-[0px] text-[#B4CFE9]">
                {number}
              </span>

              <div className="pt-[12.88px]">
                <h3 className="font-jakarta text-[16.1px] font-bold leading-[26.16px] tracking-[0px] text-[#0A0D16]">
                  {title}
                </h3>
                <p className="font-jakarta text-[16.1px] font-normal leading-[26.16px] tracking-[0px] text-[#0A0D16B2]">
                  {body}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>

      <p className="mt-[25.76px] font-inter text-[16px] font-normal leading-[29.6px] tracking-[0px] text-[#0A0D16B2]">
        Because it&apos;s built specifically for the dictation use case rather
        than repurposing a general speech recognition engine, it handles longer
        sentences and natural pauses far better than Google&apos;s native tool.
      </p>
    </section>
  );
};

export default HowItWorksSection;
